module.exports = __webpack_public_path__ + "static/beautiful-stylish-woman-hat-sunglasses-b3745f66ba6058203e2f362a4fa6344f.jpg";